module.exports = __webpack_public_path__ + "static/media/997254.a78d9e03.png";